module.exports = __webpack_public_path__ + "static/media/Stability.1927cfaf.svg";